<template>
  <common-dialog
    ref="dialog"
    ok-text="Confirm"
    :width="30"
    :hasFooter="true"
    :inputs-map="inputs"
    :resetInputs="resetDock"
    :save-cb="changeShipmentDock"
    title="Change Truck Dock"
  >
    <template v-slot:content>
      <div class="common-hint-list">
        <span> Clear dock set by leaving select empty! </span>
        {{ shipment?.dockNo }}
      </div>
    </template>
  </common-dialog>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// api
import { changeTruckPort } from '@/api/shipment'
// models
import { ShipmentDockForm } from '@/core/models/shipment'
import PagesMessage from '@/core/message/pages'
export default {
  name: 'ChangePort',
  components: {
    CommonDialog
  },
  props: {
    shipment: {
      type: Object
    }
  },
  data() {
    return {
      inputs: cloneDeep(ShipmentDockForm),
      portSelected: ''
    }
  },
  computed: {
    shipmentNo() {
      return this.shipment?.no ?? ''
    },
    shipmentId() {
      return this.shipment?.id ?? ''
    },
    formDockNo() {
      return this.inputs[2].value
    },
    sameStagePort() {
      return this.inputs[1].value
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open()
      this.inputs[0].value = this.shipmentNo
      this.inputs[2].value = false
      this.inputs[2].value = this.shipment?.dockNo ?? ''
    },
    resetDock() {
      //
    },
    changeShipmentDock(_, done, error) {
      if (this.inputs[1].value === this.shipment.dockNo) {
        error('Dock not changed')
      }
      changeTruckPort(this.shipmentId, this.formDockNo, this.sameStagePort)
        .then(res => {
          done()
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
        })
        .catch(err => error(err))
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
